<div class="row">
  <div class="col-sm-12">
    <form-builder [form]="form" (change)="onChange($event)"></form-builder>
  </div>
</div>
